export enum SubscriptionAccessSource {
  ActiveSubscription = 'ACTIVE_SUBSCRIPTION',
  InternalUse = 'INTERNAL_USE',
}
